import { render, staticRenderFns } from "./SojaEmProdes2425.vue?vue&type=template&id=79968804&lang=pug"
import script from "./SojaEmProdes2425.vue?vue&type=script&lang=js"
export * from "./SojaEmProdes2425.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports